module.exports = __webpack_public_path__ + "images/polar_helpcenter.webp";